import { useDispatch } from 'react-redux'
import ExportButton from '../../common/ExportButton'
import { pendingMembershipExportColumns } from '../../config/exportColumns/pendingMembershipExportColumns'
import { appPendingMembership } from '../../store/pendingmembers'
import TableFilter from './tableFilter'

function RequstedUser() {
	const dispatch = useDispatch()
	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Membership contribution approval</div>
					<div>
						<ExportButton
							fetchAction={params => dispatch(appPendingMembership({ ...params, loading: false }))}
							filters={{}}
							columns={pendingMembershipExportColumns}
							fileName="Pending Memberships"
							sheetName="Pending Memberships List"
							buttonText="Export Pending Memberships"
						/>
					</div>
				</div>
				<TableFilter />
			</div>
		</>
	)
}

export default RequstedUser
